import { useMemo } from 'react';
import { toast } from 'react-toastify';
import { useGetComptePaiementQuery } from 'actions/compte_paiement/queries';
import { useDeleteComptePaiementMutation, useUpdateComptePaiementMutation } from 'actions/compte_paiement/mutations';

const useComptePaiementData = (dossier_id) => {
  const {
    data: comptePaiementResponse,
    isLoading: isLoadingComptePaiement,
    isFetching,
    refetch,
  } = useGetComptePaiementQuery({ dossier_id });

  const [updateComptePaiement] = useUpdateComptePaiementMutation();
  const [deleteComptePaiement] = useDeleteComptePaiementMutation();

  const updatedcomptePaiements = useMemo(() => {
    if (comptePaiementResponse?.data && Array.isArray(comptePaiementResponse.data)) {
      return comptePaiementResponse.data.map((comptePaiement) => ({
        ...comptePaiement,
        displayName: `${comptePaiement?.compte}`,
      }));
    }
    return [];
  }, [comptePaiementResponse]);

  const handleUpdateComptePaiement = async (comptePaiementId, updateData) => {
    try {
      await updateComptePaiement({
        id: comptePaiementId,
        ...updateData,
      }).unwrap();
      refetch(); // Refetch codeJournal data from the backend
    } catch (error) {
      toast.error(`Update error: ${error.data?.error || error.message}`);
      console.error('Request failed:', error);
    }
  };

  const handleDeleteComptePaiement = async (comptePaiementId) => {
    try {
      await deleteComptePaiement({ id: comptePaiementId }).unwrap();
      toast.success('Compte de paiement supprimé avec succès');
      refetch();
    } catch (error) {
      toast.error(`Deletion error: ${error.data?.error || error.message}`);
    }
  };

  return {
    updatedcomptePaiements,
    handleUpdateComptePaiement,
    handleDeleteComptePaiement,
    refetch,
    isLoading: isLoadingComptePaiement || (isFetching && !comptePaiementResponse),
  };
};

export default useComptePaiementData;

